import * as Actions from './actions/actions';
import {updateOverlayFormFocus} from "./utilities/type";

export default class DisplayFeedbackOverlayResponseActionHandler {
    constructor(settings) {
        this._settings = settings;
    }

    initialize(store) {
        this._store = store;
    }

    getReducer() {
        return (state = {}) => { return state; }
    }

    doesHandle(message) {
        return this.hasResponseActionWithName(
            message.response,
            this._settings.ResponseActions.displayFeedbackPanes.actionName
        );
    }

    hasResponseActionWithName(response, targetName) {
        if(!response || !(response.responseActions) || response.responseActions.length === 0) return false;
        let responseAction = this.findResponseActionWithName(response.responseActions, targetName);
        return (responseAction);
    }

    findResponseActionWithName(responseActions, targetName) {
        for (var i = 0; i < responseActions.length; i++) {
            if (responseActions[i].Name === targetName) {
                return responseActions[i];
            }
        }
        return null;
    }

    process(message) {
        if(!this.doesHandle(message)) return message;

        let responseAction = this.findResponseActionWithName(
            message.response.responseActions,
            this._settings.ResponseActions.displayFeedbackPanes.actionName
        );

        let stateLocation = this._settings.stateLocations.History.feedbackPanes;
        let activeLocation = this._settings.stateLocations.History.displayFeedback;

        let renderedInfo = responseAction.Metadata
            [this._settings.ResponseActions.displayFeedbackPanes.parameters.feedbackPanes];

        let numRendered = renderedInfo.length;
        let payload = [];

        for(let i = 0; i < numRendered; i++) {
            let closeIcon = renderedInfo[i][
                this._settings.ResponseActions.displayFeedbackPanes.parameters.closeIcon
            ];
            let header = renderedInfo[i][
                this._settings.ResponseActions.displayFeedbackPanes.parameters.header
            ];
            let prompt = renderedInfo[i][
                this._settings.ResponseActions.displayFeedbackPanes.parameters.prompt
            ];
            let paneId = renderedInfo[i][
                this._settings.ResponseActions.displayFeedbackPanes.parameters.paneId
            ];
            let metadata = renderedInfo[i][
                this._settings.ResponseActions.displayFeedbackPanes.parameters.metadata
            ];
            let paneType = renderedInfo[i][
                this._settings.ResponseActions.displayFeedbackPanes.parameters.paneType
            ];

            let active = false;

            let pane = {
                closeIcon,
                header,
                prompt,
                paneId,
                type: paneType,
                metadata,
                active
            };

            payload.push(pane);
        }

        if(numRendered > 0) {
            payload[0].active = true;
        }

        updateOverlayFormFocus(true, this._store, this._settings);
        
        this._store.dispatch(Actions.setBeginDisplayFeedbackOverlay(payload, stateLocation, activeLocation));

        return message;
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-feedback-overlay/src/response-action-handler.js